import { render, staticRenderFns } from "./changePersonModal.vue?vue&type=template&id=10cf9227&scoped=true&"
import script from "./changePersonModal.vue?vue&type=script&lang=js&"
export * from "./changePersonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cf9227",
  null
  
)

export default component.exports